"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.statuses = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PropUtils = require("../../../util/PropUtils");

var _Button = _interopRequireDefault(require("../../buttons/Button"));

/**
 * @class MultiDragRow
 * @desc The default row for the MultiDrag component.
 *
 * @param {string} [data-id="multi-drag-row"]
 *    To define the base "data-id" value for the top-level HTML container.
 * @param {string} [category]
 *    The category of the row, to be displayed below its name.
 * @param {number} [column]
 *    The column index of the row. 0 represents a column to be added from, while 1
 *    represents a column to be added to and removed from.
 * @param {number} [count]
 *    The count for the row, to be displayed before its name.
 * @param {string} [iconSrc]
 *    A background image URL, which will render to an image on the left
 *    side of the component.
 * @param {number} [index]
 *    The index of the row, used to identify it in callbacks.
 * @param {string} [name]
 *    The name of the row, to be displayed to the right of the other options.
 * @param {preview} [bool]
 *    Whether or not the row is a preview. Preview rows do not render their contents.
 * @param {status} [MultiDragRow.statuses]
 *    Add status styling to row
 */

/**
 * @callback MultiDragRow~onAdd
 *    Called by add rows (row with a column value of 0) when add button is clicked.
 * @param {Object} columnInfo
 * @param {number} columnInfo.column
 *    The column index of the row.
 * @param {number} columnInfo.row
 *    The index of the row.
 */

/**
 * @callback MultiDragRow~onRemove
 *    Called by remove rows (row with a column value of 1) when remove button is clicked.
 * @param {Object} columnInfo
 * @param {number} columnInfo.column
 *    The column index of the row.
 * @param {number} columnInfo.row
 *    The index of the row.
 */

/**
 * @callback MultiDragRow~renderButton
 *    Optional function prop that renders a custom button instead of the usual add/remove buttons.
 * @param {Object} buttonInfo
 * @param {string} columnInfo.data-id
 *    The default data-id for the button.
 * @param {function} columnInfo.onClick
 *    The onClick event for the button; can be either an onAdd or onRemove depending
 *    on the row's column index.
 * @param {string} columnInfo.iconName
 *    The default iconName for the button, based on its column index.
 * @param {string} columnInfo.type
 *    The type of button being rendered, based on its column index. Can be either "add" or
 *    "remove".
 * @param {function} defaultButton
 *    The underlying Button component rendered by default in the row.
 * @param {Object} props
 *    The props passed to the MultiDragRow.
 */

/**
 * @enum {string}
 * @desc Enum for the different statuses.
 */
var statuses = {
  /** Error */
  ERROR: "error"
};
exports.statuses = statuses;

function MultiDragRow(props) {
  var category = props.category,
      column = props.column,
      count = props.count,
      dataId = props["data-id"],
      iconSrc = props.iconSrc,
      index = props.index,
      name = props.name,
      onAdd = props.onAdd,
      onRemove = props.onRemove,
      preview = props.preview,
      renderButton = props.renderButton,
      status = props.status;
  var isAdd = column === 0;
  var buttonIcon = isAdd ? "plus" : "remove";
  var buttonDataId = "row-button-".concat(isAdd ? "add" : "remove");
  var handleClick = isAdd ? function () {
    return onAdd({
      column: column,
      index: index
    });
  } : function () {
    return onRemove({
      column: column,
      index: index
    });
  };
  var iconClass = (0, _PropUtils.getIconClassName)(props);
  var button = renderButton({
    "data-id": buttonDataId,
    onClick: handleClick,
    iconName: buttonIcon,
    inline: true,
    type: isAdd ? "add" : "remove"
  }, _Button.default, props);
  var rowContent = [/*#__PURE__*/_react.default.createElement("span", {
    key: "grip",
    className: "selector-row__grip icon-grip"
  }), iconSrc && /*#__PURE__*/_react.default.createElement("div", {
    key: "image",
    className: "selector-row__image",
    "data-id": "row-image",
    style: {
      backgroundImage: "url(" + iconSrc + ")"
    }
  }), iconClass && /*#__PURE__*/_react.default.createElement("span", {
    key: "icon",
    className: (0, _classnames.default)("selector-row__icon", iconClass),
    "data-id": "row-icon"
  }), count !== undefined && /*#__PURE__*/_react.default.createElement("span", {
    key: "count",
    className: "selector-row__count",
    "data-id": "row-count"
  }, count), /*#__PURE__*/_react.default.createElement("div", {
    key: "labels",
    className: "selector-row__labels"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "selector-row__name",
    "data-id": "row-name"
  }, name), /*#__PURE__*/_react.default.createElement("div", {
    className: "selector-row__category",
    "data-id": "row-category"
  }, category)), /*#__PURE__*/_react.default.createElement("div", {
    key: "button"
  }, button)];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("selector-row", {
      "selector-row--preview": preview,
      "selector-row--error": status === statuses.ERROR
    }),
    "data-id": dataId
  }, preview ? null : rowContent);
}

MultiDragRow.propTypes = {
  category: _propTypes.default.string,
  column: _propTypes.default.number,
  count: _propTypes.default.number,
  "data-id": _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  iconSrc: _propTypes.default.string,
  index: _propTypes.default.number,
  name: _propTypes.default.string,
  onAdd: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  preview: _propTypes.default.bool,
  renderButton: _propTypes.default.func,
  status: _propTypes.default.oneOf((0, _values.default)(statuses))
};
MultiDragRow.defaultProps = {
  "data-id": "multi-drag-row",
  renderButton: function renderButton(props, ButtonComponent) {
    return /*#__PURE__*/_react.default.createElement(ButtonComponent, (0, _extends2.default)({}, props, {
      type: "standard"
    }));
  }
};
var _default = MultiDragRow;
exports.default = _default;